import * as THREE from 'three';

import { UIPanel, UIRow } from './libs/ui.js';
import { DIALOG_SCREEN_STATES } from './Config.EJX.js';

function MenubarExamples( editor ) {

	const config = editor.config;
	const signals = editor.signals;
	const strings = editor.strings;

	const container = new UIPanel();
	container.setClass( 'menu' );

	const title = new UIPanel();
	title.setClass( 'title' );
	title.setTextContent( strings.getKey( 'menubar/examples' ) );
	container.add( title );

	const options = new UIPanel();
	options.setClass( 'options' );
	container.add( options );

	// Examples

	const items = [
		{ title: 'menubar/examples/DamagedHelmet', file: 'damagedhelmet.app.json' },
		{ title: 'menubar/examples/EJXCube', file: 'ejxcube.app.json' },
	];

	const loader = new THREE.FileLoader();

	for ( let i = 0; i < items.length; i ++ ) {

		( function ( i ) {

			const item = items[ i ];

			const option = new UIRow();
			option.setClass( 'option' );
			option.setTextContent( strings.getKey( item.title ) );
			option.onClick( function () {

				if ( confirm( 'Any unsaved data will be lost. Are you sure?' ) ) {
					signals.launchDialog.dispatch(DIALOG_SCREEN_STATES.LOADING);
					signals.setLoadingStatus.dispatch(`Loading ${strings.getKey( item.title )}...`);
					loader.load( 'examples/' + item.file, async function ( text ) {

						editor.clear();
						editor.config.clearProject();
						await editor.fromJSON( JSON.parse( text ) );
						signals.closeDialog.dispatch();

					} );

				}

			} );
			options.add( option );

		} )( i );

	}

	return container;

}

export { MenubarExamples };
